// Function to get the user token
export const getToken = () => {
    const userData = getUserDataFromLocal()
    return userData ? userData?.user_device_info?.token : null
}

export const getLocalStorageItem = (key, defaultValue) => {
    const storedValue = localStorage.getItem(key);
    if (storedValue) {
        try {
            const decodedValue = decodeURIComponent(atob(storedValue));
            return JSON.parse(decodedValue);
        } catch (e) {
            console.error("Error decoding localStorage value", e);
            return defaultValue;
        }
    }
    return defaultValue;
};

export const setLocalStorageItem = (key, value) => {
    const encodedValue = btoa(encodeURIComponent(JSON.stringify(value)));
    localStorage.setItem(key, encodedValue);
};

// Function to save user data to local storage
export const saveUserDataToLocal = (userData) => {
    localStorage.setItem('userData', btoa((encodeURIComponent(JSON.stringify(userData)))))
}

// Function to remove user data from local storage
export const removeUserDataFromLocal = () => {
    localStorage.removeItem('userData')
}

// Function to get user data from local storage
export const getUserDataFromLocal = () => {
    const userDataString = localStorage.getItem('userData')
    return userDataString ? JSON.parse(decodeURIComponent(atob(userDataString))) : null
}

export const getLanguageDataFromLocal = () => {
    const language = localStorage.getItem("language")
    return language ? JSON.parse(decodeURIComponent(atob(language))) : null
}